<div class="tds-u-flex tds-u-flex-dir-col custom-gap tds-u-h-100" style="flex-grow: 1;">
  <div class="core-assist-intro-container tds-u-flex tds-u-flex-dir-col custom-gap">
    <tds-card
      mode-variant="secondary"
      header="Core Assist"
      image-placement="below-header"
      body-divider
      stretch
    >
      <div slot="body" id="CardItem" class="card" style="color: var(--tds-btn-secondary-color)">
        A smart tool for Application Owners and Support Teams working with the Diagnostic Communication Platform (DCP). CoreAssist ensures smooth deliveries and faster problem resolution. With CoreAssist, you reduce errors, resolve issues faster, and keep your systems running reliably.
        <ul style="margin-bottom: 0!important;">
          <li>
            For Application Owners: Validate that every delivery is fully compliant with DCP requirements before release.
          </li>
          <li>
            For L1 & L2 Support Agents: Quickly diagnose and fix flashing issues with built-in troubleshooting assistance.
          </li>
        </ul>
      </div>
    </tds-card>
    <tds-card
      mode-variant="secondary"
      header="Access to Core Assist"
      image-placement="below-header"
      body-divider
      stretch
    >
      <div slot="body" class="card" style="color: var(--tds-btn-secondary-color);margin: 0!important;padding: 2px 0 0 0!important;">
        <div class="brand-cards tds-u-flex tds-u-gap1">
          @for(brandAccess of brandAccessList; track brandAccess.type) {
            <tds-card
              style="flex-grow: 1;"
              mode-variant="primary"
              class="brand-card"
              body-divider
              stretch
            >
              <div slot="header">{{ brandAccess.cardHeader }}</div>
              <div slot="body" style="color: var(--tds-btn-secondary-color)" [innerHTML]="brandAccess.cardDescHtml"></div>
            </tds-card>
          }
        </div>
      </div>
    </tds-card>
  </div>
  <div class="core-assist-features-container tds-u-flex tds-u-gap2" style="flex-grow: 1">
    <tds-card
      mode-variant="secondary"
      header="Quick Links"
      image-placement="below-header"
      body-divider
      subheader="Most Popular Resources"
      stretch
      class="tds-u-flex feature-section-card quick-links-card"
    >
      <tds-icon slot="thumbnail" name="link" size="36px"></tds-icon>
      <div slot="body">
        <div class="quick-links-container tds-u-flex tds-u-flex-dir-col tds-u-gap1 tds-u-align-center">
          @for(link of quickLinks(); track link.label) {
            <a class="link-item" [routerLink]="link.route">
              {{ link.label }}
            </a>
          }
        </div>
      </div>
    </tds-card>
    <tds-card
      mode-variant="secondary"
      header="My Accessess"
      image-placement="below-header"
      body-divider
      subheader="User Access Roles"
      class="tds-u-flex feature-section-card my-access-card"
    >
      <tds-icon slot="thumbnail" name="lock" size="36px"></tds-icon>
      <div slot="body" style="color: var(--tds-btn-secondary-color)">
        <div>
          <p>{{ myAccessTitle() }}</p>
          <ul>
            @for(desc of myAccessDesc(); track desc;) {
              <li>{{ desc }}</li>
            } @empty {
              
            }
          </ul>
        </div>
      </div>
    </tds-card>
    <div class="tds-u-flex tds-u-flex-dir-col tds-u-gap1" style="flex-grow: 1; ">
      <!-- @if(showNotificationCard) { -->
        <tds-card
          id="Notifications"
          mode-variant="secondary"
          subheader="Latest system notifications"
          image-placement="below-header"
          body-divider
          stretch
        >
          <div slot="header">
            <div style="position: relative;">
              Notifications
              @if(connectionState() === 'connected') {
                <div class="ring-container">
                  <!-- <div class="ringring"></div> -->
                  <div class="circle"></div>
                </div>
              } 
            </div>
          </div>
          <tds-icon slot="thumbnail" name="notification" size="36px"></tds-icon>
          <div slot="body" id="NotificationId" class="card tds-u-overflow-auto" style="color: var(--tds-btn-secondary-color);max-height: 243px;scroll-behavior: smooth;padding: 16px!important;margin: 0!important;">
            <div class="notifications-container tds-u-flex tds-u-flex-dir-col">
              <div class="tds-u-flex tds-u-justify-between tds-u-mb1">
                <span>Notification Title</span>
                <span class="notification-count"> Notifications Period</span>
              </div>
              <app-notification-list [showEmptyMessage]="true" [entities]="notificationList" [showNotifyPeriod]="true" emptyMessage="No notifications "></app-notification-list>
            </div>
          </div>
        </tds-card>
      <!-- } -->
      <tds-card
        mode-variant="secondary"
        header="To get latest notifications on your email, subscribe to"
        image-placement="below-header"
        body-divider
        stretch
      >
        <div slot="body">
          <div class="subscribe-type-selection tds-u-flex tds-u-gap3 tds-u-align-center">
            @for(subscribeType of subscribeTypes; track subscribeType.key) {
              <tds-checkbox
                [checked]="selectedSubscribeTypes.get(subscribeType.value)"
                [value]="subscribeType.value"
                tds-aria-label="subscribe type"
                [name]="subscribeType.key"
                (tdsChange)="handleCheckSubscribe($event)"
              >
                <div slot="label">{{ subscribeType.name }}</div>
              </tds-checkbox>
            }
            <tds-button
              type="button"
              variant="primary"
              size="sm"
              text="Subscribe"
              animation="none"
              (click)="subscribeNotifyEmail()"
            ></tds-button>
          </div>
        </div>
      </tds-card>
    </div>
  </div>
</div>

